import { PDFDataProviderWrapper, PreviewProvider, PreviewTypes, VirtualizedPDFPreview } from 'shared/domains/documents';
/**
 * Renders the document as a PDF with the same viewer as the document screen.
 *
 * The PDF viewer reads the active document from the `PreviewProvider`, so we provide the previewed
 * document here instead of relying on the screen to do it.
 */
export function DocumentPreviewPdf(props) {
    const { document } = props;
    return (<PreviewProvider document={document} company={undefined}>
      <PDFDataProviderWrapper previewType={PreviewTypes.PDF}>
        <VirtualizedPDFPreview />
      </PDFDataProviderWrapper>
    </PreviewProvider>);
}
